# Перестановка элемента внутри коллекции (референсный
# UpdateContentNestedSortMutation) — сдвиг соседей делает бэкенд
mutation UpdateContentNestedSort($id: ID!, $input: UpdateContentNestedSortInput!) {
  updateContentNestedSort(id: $id, input: $input) {
    id
  }
}
